import { createFetchModule } from '../fetch';
import { mutations } from './mutations';
import { actions } from './actions';

export default {
	namespaced: true,

	state: () => ({
		selectedStore: null,
		selectedStoreID: null,
		selectedStoreRequired: false,
		selectedStorePending: false,
		fetchingSelectedStore: false,
		browserGeoPending: false,
		nearestStoreRequired: false,
		newLocationID: '',
		createdAt: null,
		nearestStore: null,
		unverifiedControlNumber: '',
		forceManualStoreSelection: false,
	}),

	getters: {
		nearestStoreResults: (state, getters) => {
			if ( !getters['nearestStoreReq/pending'] ) {
				let results = getters['nearestStoreReq/results'];

				if (results && results.results && results.results.length) {
					return results.results[0];
				} else {
					return null;
				}
			} else {
				return null;
			}
		},

		// Get the display text for when the store will open/close
		timeText: (state, getters) => {
			if (!state.selectedStore) {
				return null;
			}

			return getTimeText(state.selectedStore);
		},

		newStoreLocation: (state, getters) => {
			// Not actually a new call to it, but just getting the results from the previous call
			let newStoreLocation = getters['locationReq/results'];

			if (newStoreLocation && newStoreLocation.results && newStoreLocation.results.length) {
				return newStoreLocation.results[0];
			} else {
				return null;
			}
		},

		isValidStore: (state, getters) => {
			// Not actually a new call to it, but just getting the results from the previous call
			let validStore = getters['validateLocationReq/results'];

			return validStore ? validStore.isValid : null;
		}
	},

	mutations,
	actions,

	modules: {
		geolocationReq: createFetchModule(
			{ url: `${BEST_ONE_API_FRONTEND}/location/ip-stack/` },
			'location/onUpdate' // update action (basically a callback)
		),

		nearestStoreReq: createFetchModule(
			{ url: `${BEST_ONE_API_FRONTEND}/location/nearest-store/` },
			'location/onUpdate' // update action (basically a callback)
		),

		locationReq: createFetchModule(
			{ url: `${BEST_ONE_API_FRONTEND}/location/location-by-id/`},
			'location/onUpdate' // update action (basically a callback)
		),

		validateLocationReq: createFetchModule (
			{ url: `${BEST_ONE_API_FRONTEND}/location/validate-location/`},
			'location/onUpdate'
		),
	}
};

const weekdayArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var currentDate = new Date();
const currentDOW = currentDate.toLocaleString('en-us', { weekday: 'long' }); // Sunday, Monday etc

const getTimeText = function(selectedStore) {
	var closeTime = selectedStore[currentDOW + "Close"];

	var pretext = 'Open Until ';
	var showTime = closeTime;
	var postText = '';

	// If the store is currently closed
	if (isStoreClosedRightNow(currentDOW, selectedStore)) {
		pretext = 'Opens at ';

		// If the store is closed all day
		if (isStoreClosedOnDay(currentDOW, selectedStore, currentDate)) {
			var nextDayInfo = getNextDayOpenTime(selectedStore);

			if (nextDayInfo == false) {
				return "";
			}

			showTime = nextDayInfo.openTime;
			postText = ' on ' + nextDayInfo.day;
		} else {
			showTime = selectedStore[currentDOW + "Open"];
			postText = ' Today';
		}
	}

	return pretext + ampmTime(showTime) + postText;
}

// Checks to see if the store is currently closed
const isStoreClosedRightNow = function(currentDay, selectedStore) {
	if (isStoreClosedOnDay(currentDay, selectedStore, currentDate)) {
		return true;
	}

	var openTime = new Date(dateString(currentDate) + 'T' + selectedStore[currentDay + "Open"]);
	var closeTime = new Date(dateString(currentDate) + 'T' + selectedStore[currentDay + "Close"]);
	var currentTime = new Date().getTime();

	return (currentTime < openTime || currentTime > closeTime);
}

// Gets a nicely formatting date for the current day
const dateString = function(date) {
	var date = date ?? new Date();
	var day = date.getDate().toString();
	var month = (date.getMonth() + 1).toString();

	return [date.getFullYear(), month.padStart(2, '0'), day.padStart(2, '0')].join('-');
}

// Formats the time to nicely display on the screen
const ampmTime = function(time) {
	var datetime = new Date(dateString() + 'T' + time);
	let fmtime = datetime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
	return fmtime;
}

const getNextWeekday = function(currentDay) {
	var dayIndex = weekdayArray.indexOf(currentDay);
	return weekdayArray[(dayIndex + 1) % 6];
}

const getNextDayOpenTime = function(selectedStore) {
	var nextDayDate = new Date();
	nextDayDate.setDate(currentDate.getDate() + 1);

	var currentDay = getNextWeekday(currentDOW);
	var iterator = 0;
	var iterationCap = 6;

	// While the store is closed and we haven't looped through a full week
	while (isStoreClosedOnDay(currentDay, selectedStore, nextDayDate) && iterator < iterationCap) {
		currentDay = getNextWeekday(currentDay);
		nextDayDate.setDate(currentDate.getDate() + 1);
		iterator++;
	}

	// If we looped through a full week, then we don't know when it will open again
	if (iterator == iterationCap) {
		return false;
	}

	return {
		day: currentDay.charAt(0).toUpperCase() + currentDay.slice(1),
		openTime: selectedStore[currentDay + "Open"]
	};
}

const isStoreClosedOnDay = function(weekday, selectedStore, dateObject) {
	var openTimeCheck = selectedStore[weekday + "Open"];

	let specialDay = isSpecialDay(selectedStore, dateObject)
	if (specialDay !== false) {
		openTimeCheck = specialDay['open_time'];
	}

	return openTimeCheck == null || openTimeCheck == undefined || openTimeCheck == '00:00' || openTimeCheck == '';
}

const isSpecialDay = function(selectedStore, targetDateObject) { // returns hours or false

	let target = targetDateObject.toISOString().split('T')[0];

	let list = selectedStore[ 'special_dates' ];
	if (target in list) {
		return list[target];
	}
	list = selectedStore[ 'holiday_dates' ];
	if (target in list) {
		return list[target];
	}
	return false;

/**************************

	var subStr = 'dteclosedate';
	// Get an array of the special closed dates
	const dteClosedArray = Object.keys(selectedStore).filter(
		prop => prop.substring(0, subStr.length).toLowerCase() === subStr
	);

	var currentProp;
	var iterator;

	for (iterator = 0; iterator < dteClosedArray.length; iterator++) {
		currentProp = selectedStore[dteClosedArray[iterator]];

		if (currentProp == null || currentProp == ' ' || currentProp == '') {
			continue;
		}

		// If the property has a date equal to today's date
		if (currentProp.split('T')[0] == targetDateObject.toISOString().split('T')[0]) {
			return true;
		}
	}

	return false;

	****/
}
